<template>
  <div class="safe-tips-box" v-if="showSafeTips && isTalkStudentOrTourist">
    <div class="tips-left">
      <van-icon name="volume-o" />
      <p>说客英语严正声明：谨防退费诈骗！</p>
    </div>
    <div class="tips-right">
      <a class="detail-btn" target="_blank" href="https://mp.weixin.qq.com/s/tghIP7srkAzvCOB_UKNo4g">详情</a>
      <van-icon name="cross" class="tips-close" @click="closeTips" />
    </div>
  </div>
</template>

<script>
export default {
  created () {
  },
  data () {
    return {
      platformType: Number(this.$route.query.platformType),
      platformUserType: Number(this.$route.query.platformUserType)
    }
  },
  computed: {
    // 说客平台的学生或游客时才展示安全提示
    isTalkStudentOrTourist () {
      let isTalkStudentOrTourist = this.platformType === 0 && (this.platformUserType === 3 || this.platformUserType === 7)
      return isTalkStudentOrTourist
    },
    showSafeTips () {
      return this.$store.state.showSafeTips
    }
  },
  methods: {
    closeTips () {
      this.$store.commit('closeSafeTips')
    }
  }
}
</script>

<style lang="less" scoped>
.safe-tips-box{
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  background: #fdf6ec;
  color: #e6a23c;
  .tips-left{
    display: flex;
    align-items: center;
    p{
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 10px;
      white-space: nowrap;
      // font-size: 12px;
    }
  }
  .tips-right{
    display: flex;
    align-items: center;
    .detail-btn{
      height: 22px;
      line-height: 24px;
      padding: 0 10px;
      border-radius: 7px;
      // color: #f77e78;
      background-color: #e6a23c;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
    }
    .tips-close{
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SafeTips.vue